import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Car } from 'app/models/car.model';
import { Company } from 'app/models/company.model';
import { Poligon } from 'app/models/poligon.model';
import { UserUpdate } from 'app/models/user-update.model';
import { User } from 'app/models/user.model';
import { CarService } from 'app/services/car.service';
import { CompanyService } from 'app/services/company.service';
import { PoligonService } from 'app/services/poligon.service';
import { SimulationService } from 'app/services/simulation.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { UserService } from 'app/services/user.service';
import { BaseFormComponent } from '../../../base-form.component';

@Component({
    selector: 'app-car-form',
    templateUrl: './car-form.component.html',
    styleUrls: ['./car-form.component.scss']
})
export class SimulationCarFormComponent extends BaseFormComponent implements OnInit {
    public userlist:Array<User>
    public masterCar: Car;
    public companyId:number;
    public companyList: Array<Company>
    public selectedCompany = 0;
    private cars:Array<Car>=[];
    private _car: Car = {}
    public poligons: Array<Poligon> = [];
    public get model() {
        return this._car
    }
    public set model(v: Car) {
        this._car = v;
    }
    constructor(
        private _simulationSerive : SimulationService,
        private _toasterService : ToasterService,
        private _companyService : CompanyService,
        private _tranlateService : TranslateService
    ) {
        super();
    }

    public async ngOnInit() {
        this.companyId = parseInt(localStorage.getItem("CompanyID"))
        if (parseInt(localStorage.getItem("RoleID")) == -1) {
            this.companyList = await this._companyService.getCompanies();
        }
        this.getCarList();
        this.selectedCompany = parseInt(localStorage.getItem("CompanyID"));
        if (this.operation == "update") {
            this.masterCar = this.model;
            this.selectedCompany=this.model.companyId;
        }
        await this.polygonList();
    }

    public async getCarList(){
        this.cars= await this._simulationSerive.getCars(parseInt(localStorage.getItem("CompanyID")));
      //  this.cars = this.cars.filter(x=>x.simulation==true)
    }
    public async polygonList(){        
        try {
            this.poligons = await this._simulationSerive.getPoligons(this.selectedCompany);
        //    this.poligons = this.poligons.filter(x=>x.simulation==true)
            
        } catch (error) {
            console.warn(error);
            
        }
    }

    public async save() {
        if (this.form.invalid) {
            this._toasterService.toastWarning(this._tranlateService.instant("PLEASE_FILL_IN_THE_FORM_CORRECTLY"));
            return;
        }
        var control = this.cars.filter(x=>x.plate == this.model.plate)
        if(control.length!=0){
            this._toasterService.toastWarning(
                this._tranlateService.instant("THERE_ARE_ALREADY_VEHICLES_WITH_THIS_LICENSE_PLATE")
            )
            return;
        }
        await navigator.geolocation.getCurrentPosition(async(position:any) => {
        try {

                this.model.eLatitude = await position.coords.latitude.toString()
                this.model.eLongitude = await position.coords.longitude.toString()
                this.model.poligon = null;
                this.model.simulation=true;
                this.model.status = true;
                this.model.companyId = parseInt(localStorage.getItem("CompanyID")) ? this.selectedCompany : parseInt(localStorage.getItem("CompanyID"));
                
                        } catch (error) {
                            console.warn(error);
                        }
                        if (this.operation == "create") {
                
                            try {
                                await this._simulationSerive.addCar(this.model)
                                this.added.emit(true);
                
                            } catch (error) {
                                console.warn(error);
                                this.added.emit(false);
                
                            }
                        }
                        else {
                
                            try {
                                await this._simulationSerive.updatedCar(this.model)
                                this.updated.emit(true);
                
                            } catch (error) {
                                console.warn(error);
                                this.updated.emit(false);
                
                            }
                        }
            },error=>{
                this._toasterService.toastWarning("Konum Verisi alınamadı");
            });

    }
}
